(function () {
  function getLang() {
    // Weglot API (your console test shows this exists)
    if (window.Weglot && typeof window.Weglot.getCurrentLang === "function") {
      return (window.Weglot.getCurrentLang() || "").toLowerCase();
    }

    // fallback
    return (document.documentElement.getAttribute("lang") || "").toLowerCase();
  }

  function setImgSources(img, src, srcset) {
    if (!img || !src) return;

    // If theme uses lazysizes (data-src/data-srcset), update those too
    if (img.hasAttribute("data-src")) img.setAttribute("data-src", src);
    if (srcset && img.hasAttribute("data-srcset")) img.setAttribute("data-srcset", srcset);

    img.setAttribute("src", src);
    if (srcset) img.setAttribute("srcset", srcset);
  }

  function applyImageOverrides(root) {
    var lang = getLang();
    var scope = root || document;

    scope.querySelectorAll("[data-wg-img]").forEach(function (wrap) {
      var img = wrap.querySelector("img");
      if (!img) return;

      var defSrc = wrap.getAttribute("data-wg-src-default");
      var defSrcset = wrap.getAttribute("data-wg-srcset-default");

      var frCaSrc = wrap.getAttribute("data-wg-src-fr-ca");
      var frCaSrcset = wrap.getAttribute("data-wg-srcset-fr-ca");

      // Only switch for fr-ca and only if an override exists, otherwise fallback
      if (lang === "fr-ca" && frCaSrc) {
        setImgSources(img, frCaSrc, frCaSrcset);
      } else if (defSrc) {
        setImgSources(img, defSrc, defSrcset);
      }
    });
  }

  function bindWeglotEvents() {
    // Weglot emits events when language changes (commonly "languageChanged")
    if (window.Weglot && typeof window.Weglot.on === "function") {
      window.Weglot.on("languageChanged", function () {
        applyImageOverrides(document);
      });
    }
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", function () {
    applyImageOverrides(document);
    bindWeglotEvents();
  });

  // Shopify theme editor / dynamic section loads
  document.addEventListener("shopify:section:load", function (e) {
    applyImageOverrides(e.target);
  });
  document.addEventListener("shopify:section:reorder", function () {
    applyImageOverrides(document);
  });
  document.addEventListener("shopify:section:select", function (e) {
    applyImageOverrides(e.target);
  });
})();
